<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withTab pb-50">
      <div class="container">
        <div class="area_wrap">
<!--          <div class="text_wrap voice">-->
<!--            <h3>갑상선암 수술 후 목소리 변화</h3>-->
<!--          </div>-->
<!--          <div class="tv_wrap">-->
<!--            <iframe width="100%" height="315" src="https://www.youtube.com/embed/IM8gJ44U9RU" frameborder="0"-->
<!--                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"-->
<!--                    allowfullscreen></iframe>-->
<!--          </div>-->
          <div class="tab_header refer voice">
            <ul class="th_body tabs">
              <li class="th_content" v-for="tab in tabs" :key="tab.tabName" :class="{active: tab  === selectedTab}" @click="onClickTab(tab)">
                <p>{{tab.tabName}}</p>
              </li>
            </ul>
          </div>
          <div class="text_wrap voice">
            <div class="tw_detail">
<!--              <div class="tw_item">-->
<!--                <div class="tw_content">-->
<!--                  <p>수술을 앞두고 걱정이 많으실 것으로 생각됩니다만, 저희 땡큐서울의원는 갑상선-두경부외과 수술 전문 의원으로서,-->
<!--                    안전하고 정확한 수술을 위해 항상 최선을 다하고 있습니다. (2019년 한 해 동안 930건 이상의 입원수술을 안전하게 시행했습니다.)</p>-->
<!--                  <p>예약하신 수술 일정에 차질없이 수술이 이루어 질 수 있도록 최선을 다하고 있습니다만, 병실 사정이나 담당 원장님의 스케쥴이 급작스럽게 변경되는 경우,-->
<!--                    혹은 수술 전 추가 검사가 필요한 경우에는 불가피하게 입원 및 수술 날짜가 변경될 수 있습니다.</p>-->
<!--                </div>-->
<!--              </div>-->
              <div v-if="selectedTab === tabs[0]">
                <div class="tw_item">
                  <div class="tw_title">
                    <h2>갑상선수술 후 음성치료</h2>
                  </div>
                  <div class="tw_content">
                    <span>갑상선수술을 하면, 성대마비가 생겨 목소리가 나빠지는 경우도 드물게 있지만, 후두 주변 근육을 젖히면서 수술하는 과정으로 인해 약한 정도의 목소리 변화는 종종 생길 수 있습니다.</span>
                    <span>목소리 변화를 극복하기 위해, 스스로 터득한 잘못된 발성 방법을 사용하게 되는 경우가 흔한데, 이렇게 잘못된 발성 방법을 지속적으로 사용하면 목소리 변화가 고착되고, 성대에 무리가 가게 됩니다.</span>
                    <span>또한 갑상선수술 후에는 후두 주변 근육에 유착이 서서히 진행되기 때문에, 목소리가 서서히 나빠지거나 나빠진 목소리가 회복되는 것을 방해하기도 합니다.</span>
                    <span>땡큐서울의원에서 시행하는 ‘갑상선수술 후 음성치료’는 후두마사지, 복식호흡, 발성연습으로 구성되어, 후두 근육 유착을 예방하고 정상적인 발성 방법을 터득하여, 갑상선수술 후 목소리 변화를 치료하거나 예방하는 데 크게 도움이 됩니다.</span>
                  </div>
                </div>
                <div class="tw_item">
                  <div class="tw_title">
                    <h3>1. 갑상선수술 후 후두마사지</h3>
                  </div>
                  <div class="tw_content">
                    <span>수술 후 긴장되어 있는 후두근육 및 후두 주변 근육을 이완시키는 데 도움이 되고, 후두 근육의 유착 방지에도 도움이 됩니다. 아래와 같은 방법으로 전체 과정을 하루 3회 이상, 10분 정도 후두마사지를 하시기 바랍니다. 각 과정은 10회 정도 실시합니다.</span>
                    <vue-agile :options="myOptions" class="voiceAgile" @after-change="showCurrentSlide($event)">
                    <div class="tc_imgWrap two">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_1.png">
                      </div>
                      <div class="tc_img">
                        <img src="@/assets/images/dr_2.png">
                      </div>
                      <div class="img_text">
                        <p>갑상연골 양쪽을 손으로 감싸듯이 잡고, 좌우로 밀어 10회 정도 마사지를 합니다.</p>
                      </div>
                    </div>

                    <div class="tc_imgWrap two">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_3.png">
                      </div>
                      <div class="tc_img">
                        <img src="@/assets/images/dr_4.png">
                      </div>
                      <div class="img_text">
                        <p>같은 위치에서 위-아래 방향으로 이동하면서 10회 정도 마사지를 합니다.</p>
                      </div>
                    </div>

                    <div class="tc_imgWrap two">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_5.png">
                      </div>
                      <div class="tc_img">
                        <img src="@/assets/images/dr_6.png">
                      </div>
                      <div class="img_text">
                        <p>갑상연골 양쪽을 손으로 잡고 바깥에서 안쪽 방향으로, 또한 반대 방향으로 원을 그리듯 마사지를 합니다.</p>
                      </div>
                    </div>
                    <div class="tc_imgWrap">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_7.png">
                      </div>
                      <div class="img_text">
                        <p>귀 뒤부터 쇄골까지 이어지는 근육(흉쇄유돌근)을 손으로 지긋이 눌러 마사지를 합니다.</p>
                      </div>
                    </div>
                    <div class="tc_imgWrap two">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_8.png">
                      </div>
                      <div class="tc_img">
                        <img src="@/assets/images/dr_9.png">
                      </div>
                      <div class="img_text">
                        <p>고개를 오른쪽으로 기울이고 지그시 눌러주고, 잠시 후 오른쪽 앞 45도 정도 기울이고 지그시 눌러줍니다.</p>
                      </div>
                    </div>
                    <div class="tc_imgWrap two">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_10.png">
                      </div>
                      <div class="tc_img">
                        <img src="@/assets/images/dr_11.png">
                      </div>
                      <div class="img_text">
                        <p>왼쪽도 같은 방법으로 스트레칭 합니다.</p>
                      </div>
                    </div>
                    <div class="tc_imgWrap">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_12.png">
                      </div>
                      <div class="img_text">
                        <p>고개를 아래쪽으로 떨어뜨린 후 양손으로 지긋이 누르면서 5초간 유지합니다.</p>
                      </div>
                    </div>
                    <div class="tc_imgWrap">
                      <div class="tc_img">
                        <img src="@/assets/images/dr_13.png">
                      </div>
                      <div class="img_text">
                        <p>고개를 뒤로 젖혀줍니다. 이때 입은 살짝 벌려주는 것이 좋습니다.</p>
                        <div class="tw_sub">
                          <span class="">
                            (*주의: 고개를 뒤로 완전히 젖히는 스트레칭은 수술 2주 후부터 자주 하시기 바랍니다.)
                          </span>
                        </div>
                      </div>
                    </div>
                      <template slot="prevButton"><img src="@/assets/images/next.svg"></template>
                      <template slot="nextButton"><img src="@/assets/images/next.svg"></template>
                    </vue-agile>
                  </div>
                </div>
                <div class="tw_item">
                  <div class="tw_title">
                    <h3>2. 복식 호흡</h3>
                  </div>
                  <div class="tw_content">
                    <div class="tw_blank">
                      <span>발성의 기초가 되는 복식호흡을 연습하면, 수술 후 긴장되어 있는 근육을 이완시키는 데 도움을 줍니다.
                        복식호흡을 사용하여 발성단계로 넘어가는 것은 어려운 훈련이지만, 한번 익숙해지고 나면 편안하고 자연스럽게 가능해지므로 하루 3회 이상, 10회 정도 복식호흡을 실시하면 좋습니다.
                      </span>
                    </div>
                    <div class="tw_content_sub">
                      <div class="tc_imgWrap">
                        <div class="tc_img">
                          <img src="@/assets/images/dr_14.png">
                        </div>
                      </div>
                      <div class="sub_centerText">
                        <span class="num">준비 단계: </span>
                        <span>한 손은 가슴에 올리고, 한 손은 배 위에 올려 둡니다.</span>
                        <div class="tw_sub asterisk">
                          <span class="red">
                           Tip: 빨대를 입에 물고 하면 도움이 될 수 있습니다. (빨대 복식호흡) 이때, 빨대는 너무 깊숙이 물지 말고, 입술 끝으로 자연스럽게 고정시킵니다.
                          </span>
                        </div>
                        <span class="num two">호흡단계</span>
                        <div class="tw_num">
                          <h2>날숨 (OUT)</h2>
                          <span>빨대를 자연스럽게 문 상태에서 상처를 달래듯이 천천히 숨을 내쉽니다.</span>
                          <span>(이때 자연스럽게 배가 들어가야 하며, 공기를 내 쉴 때 빨대에서 소리가 나는지 확인합니다.)</span>
                          <h2>들숨 (IN)</h2>
                          <span>빨대를 자연스럽게 문 상태에서 꽃향기를 맡듯이 천천히 숨을 들이마십니다.</span>
                          <span>(이때 배와 옆구리가 불룩해져야 하며, 가슴이나 어깨가 올라가지 않도록 확인합니다.</span>
                          <h2>멈춤 (STOP)</h2>
                          <span>숨을 들이마신 상태에서 일정시간을 유지합니다.</span>
                        </div>
                        <span class="num third">변형된 호흡 연습</span>
                        <div class="tw_num other">
                          <h2>숨을 충분히 들이쉰 후, /스/, /즈/, /쉬/ 소리를 내면서 천천히 내쉽니다.
                            이때 최대한 오랫동안 힘들이지 않고 천천히 숨을 내쉴 수 있도록 합니다.
                            숨을 내쉴 때는 배가 천천히 들어가는지 확인합니다.</h2>
                          <h2>코로 숨을 들이마실 때, 배가 먼저 나오고 난 후, 흉곽이 늘어나는지 확인합니다.
                            갈비뼈 부분의 팽창을 확인합니다.
                          </h2>
                          <h2>숨을 내쉴 때, /스/ 소리를 내면서 내쉬는데, 이때 2번, 3번, 4번씩 나누어서 숨을 내쉽니다.</h2>
                        </div>
                        <div class="tw_sub asterisk">
                          <span class="red">
                            주의사항!
                          </span>
                          <div class="tw_sub bar">
                            <span class="red">연습하는 자세는 누운 자세 → 앉은 자세 → 일어선 자세 순으로 연습합니다.</span>
                            <span class="red">숨을 내쉴 때 목에 힘을 주지 않도록 합니다.</span>
                            <span class="red">숨을 들이마실 때는 짧고 강하게 마시고, 어깨가 올라가지 않도록 주의합니다.
                          이때, 배는 앞으로, 옆으로 나오도록 합니다. 연이어, 흉곽도 같이 팽창하는 것을 확인합니다.</span>
                            <span class="red">호흡을 할 때 가슴이 답답한 것은 긴장이 증가된 상태이므로 긴장하지 않도록 합니다.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tw_item">
                  <div class="tw_title">
                    <h3>3. 발성 연습</h3>
                  </div>
                  <div class="tw_content">
                    <div class="tw_blank">
                      <span>갑상선수술을 받은 환자분들이 목소리 관련하여 비교적 흔하게 말씀하시는 것이 목소리 톤이 낮아졌다고 하는 것입니다.
                        발성하는 음역이 달라진 것인데, 수술 후 상처치유 과정에서 생길 수 있고, 상처에 유착이 생기면서 악화되는 경우도 있습니다.
                        천천히 저절로 좋아지는 경우도 있지만, 발성 연습을 하지 않을 경우 그 상태로 고착될 수 있으므로, 꾸준히 연습하는 것이 필요합니다.
                        하루 3회 이상 연습하시고, 매일 자신의 음역을 체크해 보시기 바랍니다.
                      </span>
                    </div>
                    <div class="tw_content_sub">
                      <div class="tc_imgWrap">
                        <div class="tc_img">
                          <img src="@/assets/images/dr_15.png">
                        </div>
                      </div>
                      <div class="sub_centerText">
                        <span class="num">준비 단계: </span>
                        <span>빨대를 자연스럽게 문 상태에서 아래 악보에 따라 공기를 내 쉽니다. (이때 손을 배에 올려 두거나, 거울을 보면서 배의 움직임을 확인합니다.)</span>
                        <span class="num two">발성 단계: </span>
                        <span>숨을 충분히 들이마신 후, 부드럽게 /후/, /히/, /하/로 소리를 내면서 조금씩 숨을 내쉽니다. 목에 힘을 주지 않고, 아래 악보에 따라 음을 변경하면서 천천히 소리를 냅니다.</span>
                        <div class="tw_num">
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_1.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_2.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_3.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_4.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_5.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_6.png">
                            </div>
                          </h2>
                        </div>
                        <div class="tw_sub asterisk">
                          <span class="red">
                            주의사항!
                          </span>
                          <div class="tw_sub bar">
                            <span class="red">갑상선수술 후 발성연습은 매우 중요합니다. 수술 직후부터 시작하는 것이 가장 효과적입니다.</span>
                            <span class="red">고음을 내는 것이 어렵다고 두려워하지 말고, 꾸준히 연습해야 합니다.</span>
                            <span class="red">발성연습 전에 다른 치료가 필요할 수 있으므로, 이비인후과 전문의의 검사 후 시행해야 합니다.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="tw_item">
                  <div class="tw_title">
                    <h2>후두미세수술 전후 음성치료</h2>
                  </div>
                  <div class="tw_content">
                    <span>후두미세수술(성대수술) 전후 음성치료는 매우 중요합니다. 성대 질환은 대부분 잘못된 발성법으로 목소리(음성) 사용을 무리하게 한 것이 원인이기 때문입니다.</span>
                    <span>이번 기회에 목소리 사용 방법을 체계적으로 배워서, 평소 목소리를 잘 사용할 수 있도록 하고, 성대 질환의 재발을 예방하시기 바랍니다.</span>
                    <div class="tw_wrap">
                      <div class="tw_title">
                        <h3>1. 음성 위생을 위한 주의사항</h3>
                      </div>
                      <div class="tw_title_sub_num">
                        <p>성대의 남용 및 오용 습관을 찾아보고, 문제되는 것을 없애거나 줄이세요. (고함소리, 헛기침, 웃음, 속삭이는 소리를 내지 않습니다.)</p>
                        <p>목에 뭔가 걸리는 느낌이 있을 때, 헛기침이나 목 가다듬기를 하지 마세요. (대신 침 삼키기, 물 마시기, 하품하기를 하세요.)</p>
                        <p>말할 때 부드럽고 이완된 호흡을 하세요. (입을 벌리고 부드럽게 말하는 것이 좋습니다.)</p>
                        <p>가능한 목소리 사용(예: 말하기, 노래하기 등)을 자제하세요. (제스처를 사용하거나, 음, 흠 등 간단한 반응을 하는 것이 좋습니다.)</p>
                        <p>듣는 동안 입술을 약간 벌리며 상하의 치아를 떨어뜨려 놓으세요.</p>
                        <p>시끄러운 상황에서 말하기를 피하고, 가까이서 대화하세요.</p>
                        <p>흡연 및 음주를 피하세요.</p>
                        <p>기계소리 흉내 내기, 익살스러운 목소리 같은 괴상한 소리를 내지 마세요.</p>
                        <p>입 안과 목 안쪽을 가능한 촉촉하게 유지해 주세요. (물을 많이 드시고, 가글을 자주 하세요.)</p>
                        <p>카페인 음료(커피, 녹차, 홍차, 콜라 등) 섭취를 줄이세요. (카페인은 성대를 건조하게 만들고, 위산 역류를 악화시킵니다.)</p>
                        <p>격한 운동을 하면서 동시에 말하지 마세요. (성대근육에 과도한 압력이 가해집니다.)</p>
                        <p>취침 3시간 전에는 음식물을 섭취하지 마세요. (위산 역류의 가장 중요한 원인입니다.)</p>
                        <p>스트레스를 줄이고, 충분한 휴식을 취해주세요. (마인드 컨트롤도 도움이 됩니다.)</p>
                      </div>
                    </div>
                    <div class="tw_wrap">
                      <div class="tw_title">
                        <h3>2. 성대수술 후 복식호흡</h3>
                      </div>
                      <span>발성의 기초가 되는 복식호흡을 연습하면, 수술 후 긴장되어 있는 근육을 이완시키는 데 도움을 줍니다. 복식호흡을 사용하여 발성단계로 넘어가는 것은 어려운 훈련이지만, 한번 익숙해지고 나면 편안하고 자연스럽게 가능해지므로 하루 3회 이상, 10회 정도 복식호흡을 실시하면 좋습니다.</span>
                      <div class="tw_content_sub">
                        <div class="tc_imgWrap">
                          <div class="tc_img">
                            <img src="@/assets/images/dr_16.png">
                          </div>
                        </div>
                        <div class="sub_centerText">
                          <span class="num">준비 단계: </span>
                          <span>한 손은 가슴에 올리고, 한 손은 배 위에 올려 둡니다.</span>
                          <div class="tw_sub asterisk">
                            <span class="red">
                              Tip: 빨대를 입에 물고 하면 도움이 될 수 있습니다. (빨대 복식호흡) 이때, 빨대는 너무 깊숙이 물지 말고, 입술 끝으로 자연스럽게 고정시킵니다.
                            </span>
                          </div>
                          <span class="num two">호흡 단계</span>
                          <div class="tw_num">
                            <h2>날숨 (OUT)</h2>
                            <span>빨대를 자연스럽게 문 상태에서 상처를 달래듯이 천천히 숨을 내쉽니다.</span>
                            <span>(이때 자연스럽게 배가 들어가야 하며, 공기를 내 쉴 때 빨대에서 소리가 나는지 확인합니다.)</span>
                            <h2>들숨 (IN)</h2>
                            <span>빨대를 자연스럽게 문 상태에서 꽃향기를 맡듯이 천천히 숨을 들이마십니다.</span>
                            <span>(이때 배와 옆구리가 불룩해져야 하며, 가슴이나 어깨가 올라가지 않도록 확인합니다.)</span>
                            <h2>멈춤 (STOP)</h2>
                            <span>숨을 들이마신 상태에서 일정시간을 유지합니다.</span>
                          </div>
                          <div class="tw_sub asterisk">
                            <span class="red">
                              주의사항!
                            </span>
                            <div class="tw_sub bar">
                              <span class="red">호흡을 할 때 가슴이 답답한 것은 긴장이 증가된 상태이므로 긴장하지 않도록 합니다.</span>
                              <span class="red">복식호흡이 잘 안될 경우, 누운 자세에서 먼저 연습하는 것이 도움이 됩니다.</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tw_wrap">
                      <div class="tw_title">
                        <h3>3. 성대수술 후 호흡연습과 기초발성</h3>
                      </div>
                      <span>수술직후 발성단계에서 음성 사용은 조심스럽게 실시되어야 하며, 반드시 수술한 전문의의 소견이 있을 때만 실시할 수 있습니다.</span>
                      <span>기초 발성단계에서는 새로운 발성방법을 배우므로 억지로 소리를 내려고 하기보다는, 거울을 보면서 발성할 때 자신의 상체 움직임을 눈으로 확인하는 것이 중요합니다. 하루 3회 이상 꾸준히 실시하면 좋습니다.</span>
                      <div class="tw_content_sub">
                        <span>&lt;변형된 호흡 연습 및 기초발성&gt;</span>
                        <div class="tc_imgWrap">
                          <div class="tc_img">
                            <img src="@/assets/images/dr_17.png">
                          </div>
                        </div>
                        <div class="sub_centerText">
                          <span class="num">준비 단계: </span>
                          <span>빨대를 자연스럽게 문 상태에서 아래 악보에 따라 공기를 내 쉽니다. (이때 배에 손을 올려 두거나, 거울을 보면서 배의 움직임을 확인합니다.)</span>
                          <span class="num two">발성 단계: </span>
                          <span>숨을 충분히 들이마신 후, 부드럽게 /후/, /히/, /하/로 소리를 내면서 조금씩 숨을 내쉽니다. 목에 힘을 주지 않고, 아래 악보에 따라 음을 변경하면서 천천히 소리를 냅니다.</span>
                          <div class="tw_sub asterisk">
                            <span class="red">
                              주의사항!
                            </span>
                            <div class="tw_sub bar">
                              <span class="red">성대 수술 후 발성단계는 매우 중요합니다.</span>
                              <span class="red">전문의의 진찰 후 발성연습이 가능하다고 판단될 때만 연습을 실시합니다.</span>
                              <span class="red">발성단계에서 소리를 내 쉴 때 배가 자연스럽게 들어가는지 확인합니다.</span>
                              <span class="red">목에 힘을 주지 않은 상태에서 최대한 부드럽고, 천천히 소리를 냅니다.</span>
                            </div>
                          </div>
                        </div>
                        <div class="tw_num">
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_7.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_8.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_9.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_10.png">
                            </div>
                          </h2>
                          <h2>
                            <div class="tc_img">
                              <img src="@/assets/images/m_11.png">
                            </div>
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import { VueAgile } from 'vue-agile'
export default {
  data () {
    return {
      transDate: {
        headerName: '음성치료',
        prevUrl: '/'
      },
      tabs: [
        { tabName: '갑상선수술 후 음성치료' },
        { tabName: '후두미세수술 전후 음성치료' }
      ],
      selectedTab: '',
      setCount: false,
      myOptions: {
        mobileFirst: false,
        slidesToShow: 1,
        centerMode: true,
        autoplay: false,
        navButtons: true,
        dots: false,
        infinite: false
      }
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  mounted () {
    this.selectedTab = this.tabs[0]
  },
  methods: {
    showCurrentSlide (event) {
      /* 캐러셀 처음과 끝에서 화살표 없애기 */
      console.log(event.currentSlide)
      const btn = document.querySelector('.agile__nav-button--prev')
      const nextBtn = document.querySelector('.agile__nav-button--next')

      if (event.currentSlide === 0) {
        btn.classList.add('none')
      } else {
        btn.classList.remove('none')
      }
      if (event.currentSlide === 7) {
        nextBtn.classList.add('none')
      } else {
        nextBtn.classList.remove('none')
      }
      // Shows for example: { currentSlide: 1 }
    },
    tabBorder () {
      const active = document.querySelector('.active').parentNode
      active.classList.toggle('activeTab')
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    onClickTab (tab) {
      this.selectedTab = tab
      this.tabBorder()
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    VueAgile
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
